<template>
  <button
    :class="type"
    class="btn-xs d-flex align-items-center"
    @click="handleOpen"
  >
    <small>Download</small> <i class="ri-download-2-line ml-1"></i>
  </button>
</template>

<script>
import { previewFile } from '@/src/plugins/helpers'

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    fileUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleOpen() {
      previewFile(this.fileUrl)
    },
  },
}
</script>
